export function initContactForm7(scope = document.body) {
    var _a, _b, _c;
    const wrappersEls = [].slice.call(scope.querySelectorAll('.wpcf7'));
    for (const wrapperEl of wrappersEls) {
        if (wrapperEl.getAttribute('data-cf7-init-complete')) {
            continue;
        }
        const formEl = wrapperEl.querySelector('form');
        if (formEl && !formEl.wpcf7 && typeof ((_a = window.wpcf7) === null || _a === void 0 ? void 0 : _a.init) === 'function') {
            // Initialize Contact Form 7 bindings
            window.wpcf7.init(formEl);
        }
        const loaderEl = document.createElement('div');
        loaderEl.className = 'wpcf7-loader';
        loaderEl.innerHTML = `<div class="outerCircle"></div><div class="innerCircle"></div>`;
        wrapperEl.appendChild(loaderEl);
        wrapperEl.addEventListener('wpcf7beforesubmit', () => {
            wrapperEl.classList.add('wpcf7-loading');
        });
        wrapperEl.addEventListener('wpcf7submit', () => {
            wrapperEl.classList.remove('wpcf7-loading');
        });
        wrapperEl.addEventListener('wpcf7mailsent', () => {
            wrapperEl.classList.add('wpcf7-sented');
        });
        const formControlsEls = [].slice.call(wrapperEl.querySelectorAll('.wpcf7-form-control'));
        for (const formControlEl of formControlsEls) {
            const siblingLabelsEls = [].slice.apply(((_c = (_b = formControlEl.closest('.wpcf7-form-control-wrap')) === null || _b === void 0 ? void 0 : _b.parentElement) === null || _c === void 0 ? void 0 : _c.querySelectorAll('label')) || []);
            const addFocus = () => siblingLabelsEls.forEach(el => el.classList.add('onFocus'));
            const maybeRemoveFocus = () => !formControlEl.value && siblingLabelsEls.forEach(el => el.classList.remove('onFocus'));
            formControlEl.value && addFocus();
            formControlEl.addEventListener('focus', addFocus);
            formControlEl.addEventListener('focusout', maybeRemoveFocus);
        }
        wrapperEl.setAttribute('data-cf7-init-complete', '1');
    }
}
